import { useState } from "react";
import { Loader2, Users, X } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export const BulkAssignBar = ({ ids, reps, onClear, onDone }) => {
  const [rep, setRep] = useState("");
  const [busy, setBusy] = useState("");
  if (ids.length === 0) return null;
  const go = async (split) => {
    setBusy(split ? "split" : "one");
    try {
      const r = await api.post("/leads/assign", { ids, assigned_to: rep, split });
      toast.success(`${r.data.assigned} leads assigned: ${r.data.per_rep.filter((p) => p.count).map((p) => `${p.name} ${p.count}`).join(", ")}`);
      onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(""); }
  };
  return (
    <div className="sticky bottom-4 z-30 mt-4 flex flex-wrap items-center gap-2 rounded-2xl bg-[#0F382C] p-3 text-sm text-white shadow-xl bf-rise" data-testid="bulk-assign-bar">
      <span className="font-semibold" data-testid="bulk-selected-count">{ids.length} selected</span>
      <select value={rep} onChange={(e) => setRep(e.target.value)} className="h-9 min-w-[160px] flex-1 rounded-full border-0 bg-white/10 px-3 text-white outline-none sm:flex-none [&>option]:text-black" data-testid="bulk-assign-rep">
        <option value="">Choose salesperson</option>
        {reps.map((r) => <option key={r.id} value={r.id}>{r.name}</option>)}
      </select>
      <Button size="sm" disabled={!!busy || !rep} onClick={() => go(false)} className="rounded-full bg-[#D96B43] hover:bg-[#C45C36]" data-testid="bulk-assign-btn">{busy === "one" && <Loader2 className="mr-1 h-4 w-4 animate-spin" />}Assign</Button>
      <Button size="sm" variant="outline" disabled={!!busy || reps.length === 0} onClick={() => go(true)} className="rounded-full border-white/30 bg-transparent text-white hover:bg-white/10 hover:text-white" data-testid="bulk-split-btn">{busy === "split" ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <Users className="mr-1 h-4 w-4" />}Split equally ({reps.length})</Button>
      <button onClick={onClear} className="ml-auto rounded-full p-1.5 transition-colors hover:bg-white/10" aria-label="Clear selection" data-testid="bulk-clear-btn"><X className="h-4 w-4" /></button>
    </div>
  );
};
